module.exports = __webpack_public_path__ + "static/img/background.4ef1ea24.svg";